import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const useClientApi = () => {
	const axiosPrivate = useAxiosPrivate();

	const getAllClients = async (params = {}) => {
		const response = await axiosPrivate.get(`/api/v1/clients/tenants`, {
			params,
		});
		return response.data;
	};

	const getAllClientLocations = async (tenantId) => {
		const response = await axiosPrivate.get(
			`/api/v1/clients/user-locations/${tenantId}`,
		);
		return response.data;
	};

	const switchContextTradingPartner = async ({ clientId }) => {
		const response = await axiosPrivate.post(
			`/api/v1/trading-partners/switch-context/${clientId}`,
		);
		return response.data;
	};

	const getAllClientsForTP = async () => {
		const response = await axiosPrivate.get(
			`/api/v1/clients/trading-partner`,
		);
		return response.data;
	};

	return {
		getAllClients,
		getAllClientLocations,
		switchContextTradingPartner,
		getAllClientsForTP,
	};
};

export default useClientApi;
